import { Component, OnInit } from '@angular/core';
//import { AdataService } from '../../shared/adata.service';
import { NgForm} from '@angular/forms';
import { ThrowStmt, analyzeAndValidateNgModules } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';


@Component({
  selector: 'app-pigmy-partpayment',
  templateUrl: './pigmy-partpayment.component.html',
  styleUrls: ['./pigmy-partpayment.component.css']
})
export class PigmyPartpaymentComponent implements OnInit {

 
  myModel;
  logbranch: string;
  commonUrl: string;
  userName: string;
 
  showAndHideModal() {
    this.myModel.show();   
  }

  display='none';
  disaccdata:any;
  disacopt:any={};
  transopt:any={};
  tra:any=[];
  da:any=[];
  ldstmdata:any;
  ldstmopt:any={};
  ldst:any=[];
  title = "Pigmy Part Payment"
  actydata: any;
  actopt: any;
  ac:any={};
  sc:any=[];
  acschdata: any;
  schopt: any;
  tschopt: any;
  formpigmypart:any={};
  glsubid:number;
  accno: any;
  notaccno:any;
  acglsubid:any;
  branchdt: any;
  brnchopt:any=[];
  b :any={};
  pigmydata: any;
  pigopt: any;
  pg:any={};
  formpigmypartge: any={};
  today = new Date();  
  DateValues:string;
  calculated:number;
  ischeckd:boolean;
  ischeckm:boolean;
  nullzero:number=0;
  opdt:Date;
  bool_p:boolean;
  bool_m:boolean;

  transactype:number;
  transacscheme:number;
  transamt:number;
  transacno:string;
  transtoken_Ref:number;
  transnarration:string;
  transname:string;
  lblcurint:string;
  LBLPRECLOSEINT:string;
  lblInt:string;

  constructor(private service:UserService,private datePipe : DatePipe) 
  {
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.commonUrl = service.rootUrl;
    this.userName = localStorage.getItem('userName');
   }

  ngOnInit() 
  {
    this.actype();
    this.getbranchd();
    this.formpigmypart.actype=3;
    this.acscheme(this.formpigmypart.actype);
    this.formpigmypart.branchsel=this.logbranch;
  }

  actype()
  {
    this.actydata=this.service.gettrans();
    this.actydata.subscribe(
      (actyres:any)=>{
        this.actopt=actyres;
      }
    )
  }
  acscheme(module:number)
  {
    debugger;
    this.acschdata=this.service.getscheme(module);
    this.acschdata.subscribe(
      (schres:any)=>
      {
        this.schopt=schres;
      }
    )
  }

  tacscheme(module:number)
  {
    debugger;
    this.acschdata=this.service.getscheme(module);
    this.acschdata.subscribe(
      (schres:any)=>
      {
        this.tschopt=Array.of(schres);
      }
    )
  }

  acgetsub(schnum: any)
  {
    this.acschemeempty=false;
    if(schnum.length==1)
    {
      this.formpigmypart.glsubid='00'+schnum;
    }
    else if(schnum.length==2)
    {
      this.formpigmypart.glsubid='0'+schnum;
    }
    else if(schnum.length==3)
    {
      this.formpigmypart.glsubid=schnum;
    } //this.acglsubid= new string.concat(0,this.schnum); 
  }


  getbranchd()
  {
    debugger
  let BRANCH_ID=localStorage.getItem('BRANCH_ID');
   this.branchdt=this.service.getbranch();
   this.branchdt.subscribe(
    (bresponse:any)=>{
     // this.formpigmypart.branchsel=BRANCH_ID;
       this.brnchopt=bresponse.BranchModels;
    //  for(let i=0;i<bresponse.BranchModels.length;i++){
      //  if(BRANCH_ID==bresponse.BranchModels[i].BRANCH_ID){
       //   this.brnchopt.push(bresponse.BranchModels[i]);
      //  }
     // }
    
     // this.acsetbranch(BRANCH_ID);
      
    })
  }

  acsetbranch(bid:any)
  {
    this.formpigmypart.tbranchsel=bid;
    if(bid.length==1)
    {
      this.formpigmypart.branch='00'+bid;
      this.formpigmypart.tacbranch='00'+bid;
    }
    else if(bid.length==2)
    {
      this.formpigmypart.branch='0'+bid;
      this.formpigmypart.tacbranch='0'+bid;
    }
    else if(bid.length==3)
    {
      this.formpigmypart.branch=bid;
      this.formpigmypart.tacbranch=bid;
    }
  }

  pigmyaccountfetch(acno:string,glsubid:number,brnchid:number)
  {
    if(acno.length!=16)
      {
        this.accnoempty=true;
        swal('Acc No','Account number is not proper','warning');
      }
    else
    {

      this.accnoempty=false;
    debugger;
    let me="PART";
    this.pigmydata=this.service.fetchpigmyaxno(acno,glsubid,brnchid,me);
    this.pigmydata.subscribe(
    (pigres:any)=>{
      this.pigopt=pigres;
      console.log(pigres);
      this.bindingtoform(pigres);
      this.transopt=pigres.newob;
      console.log("transdetail");
      console.log(this.transopt);
     // this.loadstatemnts(pigres.CUSTID);
      debugger;
      this.formpigmypart.tnarration=this.getnar(acno,glsubid,pigres.NAME);
    })
  }
  }

 
  bindingtoform(res:any)
  {

    console.log(res);
    this.formpigmypart.CUSTID=res.txtcustid;  
    this.formpigmypart.ACC_ID=res.accid;  
      
    this.formpigmypart.OPEN_DT=this.getdatefun(res.TxtOpdt); //res.OPEN_DT; 
    this.formpigmypart.NAME=String(res.txtName);
    this.formpigmypart.INT_RATE=res.txtACtIntRate;
    this.formpigmypart.CARYF_BAL=res.txtCFBal;
    this.formpigmypart.BEF_BAL=res.TXTBFBAL;
    
    this.formpigmypart.PRIN_BAL=res.txtprinRepayAmt;
    this.formpigmypart.DEP_BAL=res.txtDpAmt;
    this.formpigmypart.Actul_INT=res.INT_RATE;
    this.formpigmypart.MAT_DT=  this.datePipe.transform(res.TxtMatDt,'yyyy-MM-dd');//this.getdatefun(res.END_DT);  //res.END_DT; 
    this.formpigmypart.REPAY_DT=this.getdatefun(this.today);    //this.today; //
    this.formpigmypart.strlidt=this.getdatefun(res.txtLastDt);   // res.LAST_INTDT; //
    this.formpigmypart.MCODE=res.MCODE;
    this.formpigmypart.INT_AMT=res.Txtinterest;
    this.formpigmypart.Loan_less=res.txtLessLoan;
    this.formpigmypart.NET_BAL=res.txtTransamt;
    this.formpigmypart.MAT_AMT=res.txtMatAmount;
    this.formpigmypart.REF_RATE=res.txtPreMatIntRate;
    this.formpigmypart.MIN_REQ=res.Txtminbal;
    this.formpigmypart.CARYF_BAL=res.txtCFBal;
    this.formpigmypart.INT_PAY=res.txtIntDrawn;
    this.formpigmypart.NET_INT=res.txtIntComAmt;
    this.formpigmypart.TOT_AMT=res.txtIntComAmt;
    this.formpigmypart.INTrest_PAY=res.txtIntPayable;
    this.formpigmypart.Actul_INT=res.txtIntRate;

    if( ((+res.txtprinRepayAmt)+(+res.Txtinterest)+(+res.txtLessLoan))==(+res.txtIntRate))
    this.formpigmypart.NET_BAL=res.txtTransamt;
    else
    this.formpigmypart.NET_BAL=(+res.txtprinRepayAmt)+(+res.Txtinterest)+(+res.txtLessLoan);

    this.lblcurint=res.lblcurint;

    if(res.lblcurint=="Comm Ded")
    {
     this.formpigmypart.INT_AMT=res.txtIntComAmt;
     this.formpigmypart.NET_BAL=(+res.txtprinRepayAmt)-(+res.txtIntComAmt)-(+res.txtLessLoan);
     this.lblcurint="Commission deduction";
    }

    //this.LBLPRECLOSEINT=res.LBLPRECLOSEINT;
    this.LBLPRECLOSEINT= res.LBLPRECLOSEINT!=""?res.LBLPRECLOSEINT:"Reduced Rate";
    this.lblInt=res.lblInt!=""?res.lblInt:"Intrest accumulated";
    this.lblcurint=this.lblInt;


    if(res.PERIOD_D!==0)
    {  this.ischeckd=true;  }
    else
    {this.ischeckd=false;}
    if(res.PERIOD_M!==0)  
    {  this.ischeckm=true;  }
    else
    {this.ischeckm=false;}

    var d = new Date(res.TxtOpdt);
    var curr_date = d.getDate();
     var curr_month = d.getMonth() + 1; //Months are zero based
   var curr_year = d.getFullYear();
//  console.log(curr_year + "-/" + curr_month + "-/" + curr_date);
    var end_date=new Date(this.today);
    var ed_d = end_date.getDate();
    var ed_m = end_date.getMonth() + 1; //Months are zero based
    var ed_y = end_date.getFullYear();

    debugger;
    //var matur_dt= new Date(d.setMonth(d.getMonth() + res.PERIOD_M));
    //console.log(matur_dt);

 
    var diff = Math.abs(d.getTime() - end_date.getTime());
    var diffDays = Math.ceil((diff / (1000 * 3600 * 24))-1);

    // var diffMonth=Math.ceil((diff /30));
    // console.log(diffMonth);

debugger;
    var numberOfMonths = (curr_year - ed_y) * 12 + (curr_month - ed_m) ;
    var neutral=-0
    var num_m=-(neutral)-(numberOfMonths);
    console.log(numberOfMonths);
    console.log(num_m);

    this.formpigmypart.DAYSCOMP=diffDays;

    if (res.PERIOD_D!=0)
    {
      if(diffDays<=res.PERIOD_D)
        {
          this.bool_p=true;
          alert("Pre-Mature CLosure!");
          this.title="Account Closure::Pre-Mature Closure       'Days Based' ";
        }
      else
        {

        } 
    }
//preclosure monthly check
    if(res.PERIOD_M!=0)
    {   debugger;


    if(num_m<=res.PERIOD_M )
     {
      this.bool_m=true;
       alert("Pre-Matue Closure monthly based");
       this.title="Account Closure::Pre-Mature Closure       'Monthly Based'";
     }
    }

    console.log(diffDays);
  }
    getdatefun(indt:any)
    {
      this.DateValues=this.datePipe.transform(indt,'dd-MM-yyyy');
      return this.DateValues;
   }
 
  
   calculnet(prin:number,intamt:number,loanamt:number,otheramt:number,balcf:number)
   {

      if(this.lblcurint=="Commission deduction")
     {
      debugger;
      this.calculated=(+this.checknull(prin))-(+this.checknull(intamt))-(+this.checknull(loanamt))-(+this.checknull(otheramt));
      this.formpigmypart.NET_BAL=this.calculated;
      this.formpigmypart.tamt=this.calculated;
      this.balmin(this.calculated,balcf);

     }
     else
     {
      debugger;
      this.calculated=(+this.checknull(prin))+(+this.checknull(intamt))-(+this.checknull(loanamt))-(+this.checknull(otheramt));
      this.formpigmypart.NET_BAL=this.calculated;
      this.formpigmypart.tamt=this.calculated;
      this.balupdate(this.calculated,balcf);
     }
   }
   calminusnet(prin:number,intamt:number,loanamt:number,otheramt:number,balcf:number)
   {
     debugger;
     this.calculated=(+this.checknull(prin))+(+this.checknull(intamt))-(+this.checknull(loanamt))-(+this.checknull(otheramt));
     this.formpigmypart.NET_BAL=this.calculated;
     this.formpigmypart.tamt=this.calculated;
     this.balmin(this.calculated,balcf);
   }

   checknull(chknum:number)
   {
     debugger;
     if(chknum==null)
        return 0;
      else
        return chknum;
   }

   acschemeempty:boolean=false;
   accnoempty:boolean=false;

   onSubmit(formpigmypart:NgForm)
  {
    if(formpigmypart.value.acscheme==undefined||null)
      this.acschemeempty=true;;
    if(formpigmypart.value.branch==undefined || formpigmypart.value.yrnd==undefined ||formpigmypart.value.accno==undefined ||formpigmypart.value.glsubid==undefined)
       this.accnoempty=true;
    else
      this.insertrecord(formpigmypart);
  }
  insertrecord(formpigmypart: NgForm)
  {
    debugger;
    console.log('Form');
    console.log(formpigmypart.value);
    formpigmypart.value.Me="PART";
    document.getElementById('loader-spinner').style.display = "block";
    this.service.Pigmypartpay(formpigmypart.value).subscribe(res=>{
      this.resetForm(formpigmypart)
      document.getElementById('loader-spinner').style.display = "none";
      
      swal('Pigmy Partpayment Done!', 'INFO', 'success');
     },

    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      swal('Warning!', 'Something went wrong', 'warning');
    });



  }

  resetForm(form?: NgForm)
  {
    if(form!=null)
    {
      this.formpigmypart.CUSTID='';
      this.formpigmypart.OPEN_DT='';
      this.formpigmypart.NAME='';
      this.formpigmypart.INT_RATE=null;
      this.formpigmypart.CARYF_BAL=null;
      this.formpigmypart.BEF_BAL=null;
      this.formpigmypart.NET_BAL=null;
      this.formpigmypart.PRIN_BAL=null;
      this.formpigmypart.DEP_BAL=null;
      this.formpigmypart.Actul_INT=null;
      this.formpigmypart.MAT_DT='';
      this.formpigmypart.REPAY_DT='';
      this.formpigmypart.LAST_INTDT='';
      this.formpigmypart.MCODE='';
      
      this.formpigmypart.actype='';
      this.formpigmypart.acscheme='';
      this.formpigmypart.branchsel='';
      this.formpigmypart.transtype='';
      this.formpigmypart.strlidt='';

      
      this.formpigmypart.MAT_AMT=null;
      this.formpigmypart.REF_RATE=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INTrest_PAY=null;
      this.formpigmypart.MIN_REQ=null;
      this.formpigmypart.INT_PAY=null;
      this.formpigmypart.NET_INT=null;
      this.formpigmypart.TOT_AMT=null;
      this.ischeckd=false;
      this.ischeckm=false;
      this.formpigmypart.branch=null;
      this.formpigmypart.yrnd=null;
      this.formpigmypart.accno=null;
      this.formpigmypart.glsubid=null;
      
      this.formpigmypart.tactype='';
      this.formpigmypart.tacscheme='';
      this.formpigmypart.tbranchsel='';
      this.formpigmypart.tamt='';
      this.formpigmypart.ttoken_Ref='';
      this.formpigmypart.tnarration='';
      this.formpigmypart.tacbranch='';
      this.formpigmypart.tacyrnd='';
      this.formpigmypart.tacno='';
      this.formpigmypart.tglsubid='';
      this.formpigmypart.DAYSCOMP='';

  }
 }

 tsetsubid(glsid:any)
 {
  if(glsid.length==1)
    {
      this.formpigmypart.tglsubid='00'+glsid;
    }
    else if(glsid.length==2)
    {
      this.formpigmypart.tglsubid='0'+glsid;
    }
    else if(glsid.length==3)
    {
      this.formpigmypart.tglsubid=glsid;
    } 
 }
 
 getnar(acno:string,glsubid:any,name:string)
 {
   debugger;
   var nar="By "+glsubid.substring(1,2)+acno.substring(8,6)+" / "+name;
    return nar;
 }


 bindtotable(tactype:number,tacscheme:number,tamt:number,tacbranch:string,tacyrnd:string,tacno:string,tglsubid:string,ttoken_Ref:number,tnarration:string,tname:string)
 {
   debugger;

   this.transactype=tactype;
   this.transacscheme=tacscheme;
   this.transamt=tamt;
   this.transacno=  tacbranch+tacyrnd+tacno+tglsubid;
   this.transtoken_Ref=ttoken_Ref; 
  this.transnarration=tnarration;
  this.transname=tname;
 }

 balupdate(netamt:number,CARYF_BAL:number)
 {
  debugger;
  var calcula=this.calculated=(+this.checknull(netamt))-(+this.checknull(CARYF_BAL));
  //(+netamt)+(+CARYF_BAL);
  this.formpigmypart.CARYF_BAL=calcula;
 }
 balmin(netamt:number,CARYF_BAL:number)
 {
  debugger;
  var calcula=this.calculated=(+this.checknull(CARYF_BAL))-(+this.checknull(netamt));
  //(+netamt)+(+CARYF_BAL);
  this.formpigmypart.CARYF_BAL=calcula;
 }

 aonKey(branch:any,yrnd:any,acn:any,subid:any)
 { // without type info
  
  this.accno = branch+yrnd+acn+subid;    //event.target.value + ' | ';
  console.log(this.accno);
  this.pigmyaccountfetch(this.accno,subid,branch);
}
 openModalDialog(){
  this.display='block'; //Set block css
}

closeModalDialog(){
this.display='none'; //set none css after close dialog
}

onKey(branch:any,yrnd:any,acn:any,subid:any,branch_id:number)
  {
    debugger;
    let me="PART";
  this.accno = this.checkstringnul(branch)+this.checkstringnul(yrnd)+this.checkstringnul(acn)+this.checkstringnul(subid);
  this.notaccno=this.checkstringnul(acn)+this.checkstringnul(subid);
    if(this.accno.length<16)
    {
      this.disaccdata=this.service.getallaccountunivers(this.notaccno,subid,branch_id);
      this.disaccdata.subscribe(
        (accres:any)=>{
          this.disacopt=accres;
          console.log(this.disacopt);
          this.openModalDialog();
        })
     
    }
    else
    {
      this.pigmyaccountfetch(this.accno,subid,branch);
    }
  }

  checkstringnul(str:string)
  {
    if(str!=null)
    {
      return str;
    }
    else
     return "";
  }

  Getbynumber(accn:string,subid:number,branch:number)
  {
    branch=Number(this.logbranch);
    debugger;
    for(let i=0;i< this.disacopt.length;i++)
    {
      if(this.disacopt[i].ACC_NO==accn)
      { debugger;
        let accnum=this.disacopt[i].ACC_NO;
        let acnaqm=this.disacopt[i].NAME;
        this.formpigmypart.branch=accnum.substring(0,3);
        this.formpigmypart.yrnd=accnum.substring(7,3);
        this.formpigmypart.accno=accnum.substring(13,7);
       // this.formpigmypart.glsubid=accnum.substring(16,13);
       debugger;
      //  console.log(accnum);
      //  console.log(" branch");
      //  console.log(accnum.substring(0,3));
      //  console.log("yr");
      //  console.log(accnum.substring(7,3));
      //  console.log("acc_no");
      //  console.log(accnum.substring(13,7));
      //  console.log("subid");
      //  console.log(accnum.substring(16,13));
        this.pigmyaccountfetch(accnum,subid,branch);
        this.closeModalDialog();
      }
    }
  }
  Getbyname(name:string,subid:number,branch:number)
  {
    branch=Number(this.logbranch);
    debugger;
    for(let i=0;i< this.disacopt.length;i++)
    {
      if(this.disacopt[i].NAME==name)
      {
        debugger;
        let accnum=this.disacopt[i].ACC_NO;
        let acnaqm=this.disacopt[i].NAME;
        this.formpigmypart.branch=accnum.substring(0,3);
        this.formpigmypart.yrnd=accnum.substring(7,3);
        this.formpigmypart.accno=accnum.substring(13,7);
       // this.formpigmypart.glsubid=accnum.substring(16,13);
        this.pigmyaccountfetch(accnum,subid,branch);
        this.closeModalDialog();
      } 
    }

  }

  loadstatemnts(custid:number)
  {
    debugger;
   this.ldstmdata=this.service.loadstmt(custid);
   this.ldstmdata.subscribe(
    (ldstres:any)=>
    {
        console.log(ldstres);
    }
   )
  }

  productreport()
  {
    window.open(this.commonUrl+'/Reports/PigmyProduct/PigmyProductReport.aspx?userName='+this.userName);
  }
}



// WEBPACK FOOTER //
// ./src/app/general-transaction/pigmy-partpayment/pigmy-partpayment.component.ts